export const FISHING_MENU = [
  {
    _id: '63c1030bb64f6450d162f5c8',
    component_content_id: '63806c9340b4a5aea422f051',
    title: {
      'en-US': 'Funky games',
      'th-TH': 'Funky games',
      'zh-CN': 'Funky games'
    },
    description: {
      'en-US': 'Funky games',
      'th-TH': 'Funky games',
      'zh-CN': 'Funky games'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 1773,
    game_provider_id: 33,
    sequence: 2,
    image_desktop_path: {
      'en-US': 'demo/games/fishing/image-1-en.png',
      'th-TH': 'demo/games/fishing/image-1-th.png',
      'zh-CN': 'demo/games/fishing/image-1-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/fishing/image-1-en-mobile.png',
      'th-TH': 'demo/games/fishing/image-1-th-mobile.png',
      'zh-CN': 'demo/games/fishing/image-1-ch-mobile.png'
    },
    __v: 0,
    created_at: '2023-01-13T07:06:51.971Z',
    updated_at: '2025-06-17T06:28:47.418Z'
  },
  {
    _id: '65fbafd87f2d6fc24bfc7334',
    component_content_id: '63806c9340b4a5aea422f051',
    title: {
      'en-US': 'fishing game',
      'th-TH': 'fishing game',
      'zh-CN': 'fishing game'
    },
    description: {
      'en-US': 'fishing game',
      'th-TH': 'fishing game',
      'zh-CN': 'fishing game'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    game_id: 0,
    game_provider_id: 8,
    sequence: 1,
    image_desktop_path: {
      'en-US': 'demo/games/fishing/image-2-en.png',
      'th-TH': 'demo/games/fishing/image-2-th.png',
      'zh-CN': 'demo/games/fishing/image-2-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/fishing/image-2-en-mobile.png',
      'th-TH': 'demo/games/fishing/image-2-th-mobile.png',
      'zh-CN': 'demo/games/fishing/image-2-ch-mobile.png'
    },
    __v: 0,
    created_at: '2024-03-21T03:56:08.128Z',
    updated_at: '2025-06-17T06:28:47.388Z',

    currency: 'thb',
    item_id: '65fbafd87f2d6fc24bfc7334'
  },
  {
    _id: '684fbff94d76ce42906e9db4',
    component_content_id: '63806c9340b4a5aea422f051',
    title: {
      'en-US': 'Test'
    },
    description: {
      'en-US': 'test'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    currency: 'thb',
    sequence: 3,
    link: null,
    image_desktop_path: {
      'en-US': 'demo/games/fishing/image-3-en.png',
      'th-TH': 'demo/games/fishing/image-3-th.png',
      'zh-CN': 'demo/games/fishing/image-3-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/fishing/image-3-en-mobile.png',
      'th-TH': 'demo/games/fishing/image-3-th-mobile.png',
      'zh-CN': 'demo/games/fishing/image-3-ch-mobile.png'
    },
    __v: 0,
    created_at: '2025-06-16T06:55:53.986Z',
    updated_at: '2025-06-17T06:28:47.516Z'
  },
  {
    _id: '684fc0a54d76ce42906e9dbf',
    component_content_id: '63806c9340b4a5aea422f051',
    title: {
      'en-US': 'test'
    },
    description: {
      'en-US': 'test'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    currency: 'thb',
    sequence: 0,
    link: null,
    image_desktop_path: {
      'en-US': 'demo/games/fishing/image-4-en.png',
      'th-TH': 'demo/games/fishing/image-4-th.png',
      'zh-CN': 'demo/games/fishing/image-4-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/fishing/image-4-en-mobile.png',
      'th-TH': 'demo/games/fishing/image-4-th-mobile.png',
      'zh-CN': 'demo/games/fishing/image-4-ch-mobile.png'
    },
    __v: 0,
    created_at: '2025-06-16T06:58:45.585Z',
    updated_at: '2025-06-17T06:28:47.289Z'
  },
  {
    _id: '684fc0a54d76ce42906e9db1',
    component_content_id: '63806c9340b4a5aea422f051',
    title: {
      'en-US': 'test'
    },
    description: {
      'en-US': 'test'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    currency: 'thb',
    sequence: 0,
    link: null,
    image_desktop_path: {
      'en-US': 'demo/games/fishing/image-5-en.png',
      'th-TH': 'demo/games/fishing/image-5-th.png',
      'zh-CN': 'demo/games/fishing/image-5-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/fishing/image-5-en-mobile.png',
      'th-TH': 'demo/games/fishing/image-5-th-mobile.png',
      'zh-CN': 'demo/games/fishing/image-5-ch-mobile.png'
    },
    __v: 0,
    created_at: '2025-06-16T06:58:45.585Z',
    updated_at: '2025-06-17T06:28:47.289Z'
  },
  {
    _id: '684fc0a54d76ce42906e9db2',
    component_content_id: '63806c9340b4a5aea422f051',
    title: {
      'en-US': 'test'
    },
    description: {
      'en-US': 'test'
    },
    is_visible: true,
    is_active: true,
    link_type: 1,
    currency: 'thb',
    sequence: 0,
    link: null,
    image_desktop_path: {
      'en-US': 'demo/games/fishing/image-6-en.png',
      'th-TH': 'demo/games/fishing/image-6-th.png',
      'zh-CN': 'demo/games/fishing/image-6-ch.png'
    },
    image_mobile_path: {
      'en-US': 'demo/games/fishing/image-6-en-mobile.png',
      'th-TH': 'demo/games/fishing/image-6-th-mobile.png',
      'zh-CN': 'demo/games/fishing/image-6-ch-mobile.png'
    },
    __v: 0,
    created_at: '2025-06-16T06:58:45.585Z',
    updated_at: '2025-06-17T06:28:47.289Z'
  }
]
